<template>
  <div class="yt-wrapper" :class="{ autoPlay: autoPlay || liveStream }" v-observable="{ callback: onObservable }">
    <iframe
      v-if="liveStream"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowfullscreen
      frameborder="0"
      :src="`https://www.youtube.com/embed/live_stream?channel=${id}&autoplay=1`"
    />
    <LiteYouTubeEmbed v-else :id="id" ref="video" poster="maxresdefault" :title="title" />
  </div>
</template>

<script setup lang="ts">
  import LiteYouTubeEmbed from 'vue-lite-youtube-embed'
  import 'vue-lite-youtube-embed/style.css'

  const props = defineProps({
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    autoPlay: {
      type: Boolean,
      default: false,
    },
    liveStream: {
      type: Boolean,
      default: false,
    },
  })

  const video = ref()

  const onObservable = (isVisible: boolean) => {
    if (isVisible) {
      if (video.value.getPlayerInstance()) video.value.playVideo()
      else if (props.autoPlay) video.value.addIframe()
    } else if (video.value.getPlayerInstance()) video.value.pauseVideo()
  }
</script>
<style lang="scss" scoped>
  .yt-wrapper {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    > * {
      width: 100%;
    }
  }
  iframe {
    width: 100%;
    aspect-ratio: 16/9;
    z-index: 1;
  }

  @media (min-aspect-ratio: 16/9) {
    iframe {
      height: 100%;
    }
  }
</style>
